import React from "react"
import './visit.scss';
import images from '../../assets/teide-dOr';
import logoTeidedOr from '../../assets/logoTeidedOr.png';
import triassicMap from '../../assets/TriassicMap.jpg';

function Visit() {

    const slides = images.map((item, i) => <div className="slide" key={i}><img src={item} alt={`Teide ${i}`}/></div>)

    return (
        <section id="visita" className="scroller">
            <h3>Visítanos</h3>
            <div className="background">
                <article>
                    <p>
                        ¡Acércate a Tenerife y visita el único y mejor parque de dinosaurios del planeta!<br/>
                        Situado en un enclave espectacular donde tanto tú como los dinosaurios os encontraréis como en casa. Ven, conócelos, haz amigos y vuelve siempre que quieras.
                        Tienes disponible un descuento en la compra del billete de avión con la compra de tu entrada.
                    </p>
                    <iframe title="localización Teide" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d899379.3218728028!2d-17.083120720034394!3d28.292250635193092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc4029effe8682ed%3A0xb01a4bf1c84baf3c!2sTenerife!5e0!3m2!1ses!2ses!4v1684621827072!5m2!1ses!2ses" width="300" height="300" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </article>
            </div>
            <div className="background">
                <article>
                    <img className="logo" src={logoTeidedOr} alt="logo Teide d'Or resort"/>
                    <p>
                        Relájate con las espléndidas vistas y los más increíbles espectáculos en nuestras  instalaciones ideadas por los mejores arquitectos. ¡No se ha reparado en gastos!
                    </p>
                </article>
                <div className="slider-container">
                    <div className="slider" >
                        {slides}
                    </div>
                </div>
            </div>
            <div className="background">
                <article>
                    <p className="map">
                        ¿Aún no sabes que te espera en Triassic Park? ¿Necesitas más información para preparar tus vacaciones ideales?<br/>
                        Aquí tienes el mapa para hacerte una pequeña idea. Los puertos Este y Oeste serán vuetra puerta de entrada por mar y luego... ¡La isla es tuya! ¿Te interesa ver los Stegosaurus? Tus alojamiento ideal es Teide d'Or Sur. Si prefieres pasar el día avisatando Pterodactylus, ¡Teide d'Or Norte es tu sitio!
                    </p>
                    <img className="mapa" src={triassicMap} alt="Mapa de Triassic Park con detalle de todas las localizaciones más importantes"/>
                </article>
            </div>
            
        
        </section>
    );
}

export default Visit;
